export default __webpack_public_path__ + "static/aaa-xl-6c03b075bc6c43ac72f43ec762ad5e49.svg";